<div class="input-wrapper" [ngClass]="{ error: !inputIsValid, disabled: inputIsDisabled }">
    <my-date-picker
        #viewChildMyDatePicker
        id="{{ _id }}"
        class="date-picker"
        [(ngModel)]="value"
        (ngModelChange)="_onChange($event)"
        [locale]="_currentLocale"
        [options]="_datePickerOptions"
        (inputFocusBlur)="_onFocusOrBlur($event)"
        placeholder="{{ inputIsRequired ? inputName + '*' : inputName }}"
    >
    </my-date-picker>
    <label
        tabindex="-1"
        [tcTooltip]="inputName"
        [onlyEllipsisTooltip]="true"
        *ngIf="(value || _dateAsString) && inputName"
        htmlFor="{{ _id }}"
        >{{ inputName }}
        <span *ngIf="inputIsRequired">*</span>
    </label>
</div>
